import React from 'react';
import { Search } from 'lucide-react';
import { MobileMenuButton } from './MobileMenuButton';
import { BrandBlock } from './BrandBlock';
import { AppSwitcher } from './AppSwitcher';
import { ActiveAppLabel } from './ActiveAppLabel';
import { GlobalSearch } from './GlobalSearch';
import { ThemeToggle } from './ThemeToggle';
import { TopbarSubrow } from './TopbarSubrow';
import { UserMenu } from './UserMenu';
import { MobilePageTitle } from '../mobile/MobilePageTitle';
import { useMobileShell } from '@shared/shell';
import { Button } from '@shared/ui/button';

export const Topbar: React.FC = () => {
  const { openSearch } = useMobileShell();

  return (
    <header
      data-shell-header
      data-app-chrome
      className="sticky top-0 z-40 shadow-sm border-b border-border/60 isolate pt-[var(--safe-top)] pl-[var(--safe-left)] pr-[var(--safe-right)] bg-navbar"
    >
      <div className="h-[var(--mobile-header-h)] short:h-11 md:h-12 bg-navbar text-navbar-foreground border-b border-navbar-border px-3 flex items-center justify-between gap-2">
        {/* Left Side */}
        <div className="flex md:hidden items-center gap-2 min-w-0 flex-1">
          <MobileMenuButton />
          <MobilePageTitle />
        </div>

        <div className="hidden md:flex items-center gap-2 min-w-0">
          <BrandBlock />
          <span className="h-4 w-px bg-navbar-border mx-1 shrink-0" aria-hidden />
          <AppSwitcher />
          <ActiveAppLabel />
        </div>

        {/* Right Side */}
        <div className="flex items-center gap-1.5 shrink-0">
          {/* Mobile Search Button */}
          <Button
            variant="ghost"
            size="icon"
            onClick={openSearch}
            className="md:hidden h-8 w-8 text-navbar-muted hover:text-navbar-foreground hover:bg-navbar-accent shrink-0 pressable"
            aria-label="Search"
          >
            <Search className="h-4 w-4" />
          </Button>

          {/* Desktop Search & Theme */}
          <div className="hidden md:flex items-center gap-1.5 shrink-0">
            <GlobalSearch />
            <ThemeToggle />
            <span className="h-4 w-px bg-navbar-border mx-1 shrink-0" aria-hidden />
          </div>

          {/* User Menu - single instance */}
          <UserMenu />
        </div>
      </div>
      <TopbarSubrow />
    </header>
  );
};
